import React, { useState } from "react";
import { Radio, Input, Form, Select } from "antd";
import { Option } from "antd/es/mentions";

const Company = ({ formData, setFormData }) => {
  const [value, setValue] = useState(formData.representingCompany || 1);

  const onChange = (e) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
    setFormData({ ...formData, representingCompany: selectedValue });
  };

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (value) => {
    setFormData({ ...formData, businessActivity: value });
  };

  return (
    <>
      <div className="col-md-12 col-sm-12">
        <Radio.Group onChange={onChange} value={value}>
          <Radio style={radioStyle} value={1}>
            Self employed.. No Company Information, Direct Contact
          </Radio>
          <Radio style={radioStyle} value={2}>
            Representing Company.. Provide Company Information
          </Radio>
        </Radio.Group>
      </div>
      <br />
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Company Name*"
          name="companyName"
          rules={
            value === 1
              ? []
              : [{ required: true, message: "This field is required." }]
          }
        >
          <Input
            name="companyName"
            className="registration-antd-input-tag"
            disabled={value === 1}
            value={formData.companyName}
            onChange={handleChange}
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Website*"
          name="website"
          rules={
            value === 1
              ? []
              : [{ required: true, message: "This field is required." }]
          }
        >
          <Input
            name="website"
            className="registration-antd-input-tag"
            disabled={value === 1}
            value={formData.website}
            onChange={handleChange}
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Nature Of Business Activity *"
          name="businessActivity"
          rules={[{ required: true, message: "This field is required." }]}
        >
          <Select
            showSearch
            placeholder="Select Business Activity"
            optionFilterProp="children"
            onChange={handleSelectChange}
            name="businessActivity"
            className="registration-antd-input-tag"
            value={formData.businessActivity}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="Jeweler">Jeweler</Option>
            <Option value="Diamond Broker">Diamond Broker</Option>
            <Option value="Individual">Individual</Option>
          </Select>
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Business Relationship Period *"
          name="businessReletionshipPeriod"
          rules={
            value === 1
              ? []
              : [{ required: true, message: "This field is required." }]
          }
        >
          <Input
            name="businessReletionshipPeriod"
            className="registration-antd-input-tag"
            disabled={value === 1}
            value={formData.businessReletionshipPeriod}
            onChange={handleChange}
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Name Of Promoter / Partner / Director"
          name="promoterName"
          rules={
            value === 1
              ? []
              : [{ required: true, message: "This field is required." }]
          }
        >
          <Input
            name="promoterName"
            className="registration-antd-input-tag"
            disabled={value === 1}
            value={formData.promoterName}
            onChange={handleChange}
          />
        </Form.Item>
      </div>
      <div className="col-md-6 col-sm-12">
        <Form.Item
          label="Business Registration No"
          name="businessRegistrationNo"
          rules={
            value === 1
              ? []
              : [{ required: true, message: "This field is required." }]
          }
        >
          <Input
            name="businessRegistrationNo"
            className="registration-antd-input-tag"
            disabled={value === 1}
            value={formData.businessRegistrationNo}
            onChange={handleChange}
          />
        </Form.Item>
      </div>
    </>
  );
};

export default Company;
